import React from 'react';
import { DataGrid } from '../../common/datagrid/ResponsiveDataGrid';
import CustomLoadingOverlay from '../../common/datagrid/CustomLoadingOverlay';

const OrderBookHistoryList = ({ apiRef, columns, rows, loading , handleRowClick,columnVisibilityModel}) => {
  return (
    <div style={{ display: 'flex', height: '350px' }}>
    <div style={{ flexGrow: 1 }}>
        <DataGrid
          rows={rows ? rows : []}
          columns={columns}
          components={{
            LoadingOverlay: CustomLoadingOverlay,
          }}
          loading={loading}
          apiRef={apiRef}
          onRowClick={handleRowClick}
          columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}
        />
      </div>
    </div>
  );
};

export default OrderBookHistoryList;
